export const deleteUser = async (
    API_URL: string,
    token: string,
    employerId: string,
    employeeId: string,
) => {
    const response = await fetch(
        `${API_URL}/employers/${employerId}/employees/${employeeId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }
      );

      if (!response.ok)
        throw new Error("There was a problem deleting this user");
}